import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function Unauthorized() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="page">
      <h2>Unauthorized</h2>
      <p>You do not have permission to access this page.</p>
      <button type="button" className="primary-page-btn" onClick={handleLogout}>
        Logout and sign in again
      </button>
    </div>
  );
}